<div class="plugin-form">

  <p class="plugin-section-title">Software Configuration</p>

  <!-- OS selector -->
  <div class="os-grid">
    <div *ngFor="let os of osOptions"
         class="os-img"
         [class.selected]="selectedOperatingSystem === os.id"
         (click)="selectOperatingSystem(os.id)">
      <img src="../../../../../assets/images/resources/software/os/{{os.id}}.png"
           [alt]="os.name" class="os-thumb">
      <div class="os-name">{{ os.name }}</div>
    </div>
  </div>

  <!-- OS Version -->
  <mat-form-field appearance="outline" class="form-field-full">
    <mat-label>OS Version</mat-label>
    <input matInput [matAutocomplete]="osVersionAuto"
      [(ngModel)]="osVersionSearch"
      (ngModelChange)="filterOsVersions($event)"
      placeholder="Search OS version…">
    <mat-autocomplete #osVersionAuto (optionSelected)="onOsVersionSelected($event.option.value)">
      <mat-option *ngFor="let v of filteredOsVersions" [value]="v">{{ v.name }}</mat-option>
    </mat-autocomplete>
  </mat-form-field>

  <!-- Hyper-V toggle -->
  <div class="hyper-v-row">
    <span class="toggle-label-text">Hyper-V</span>
    <mat-icon class="info-icon" matTooltip="Enables virtualization in the virtual machine">info_outline</mat-icon>
    <mat-slide-toggle [(ngModel)]="softwareData.hyperV" color="primary">
      {{ softwareData.hyperV ? 'True' : 'False' }}
    </mat-slide-toggle>
  </div>

  <!-- SDKs & Frameworks -->
  <mat-form-field appearance="outline" class="form-field-full">
    <mat-label>SDKs &amp; Frameworks</mat-label>
    <mat-chip-grid #sdkChipGrid>
      <mat-chip-row *ngFor="let id of softwareData.sdks" (removed)="removeChip('sdks', id)">
        {{ getOptionName(sdkOptions, id) }}
        <button matChipRemove><mat-icon>cancel</mat-icon></button>
      </mat-chip-row>
      <input placeholder="Add SDK…" [matChipInputFor]="sdkChipGrid" [matAutocomplete]="sdkAuto"
        [(ngModel)]="sdkSearchInput" (ngModelChange)="onSdkSearch($event)">
    </mat-chip-grid>
    <mat-autocomplete #sdkAuto="matAutocomplete"
      (optionSelected)="addChip('sdks', $event.option.value); sdkSearchInput = ''">
      <mat-option *ngFor="let opt of sdkAutocompleteOptions" [value]="opt.id">{{ opt.name }}</mat-option>
    </mat-autocomplete>
  </mat-form-field>

  <!-- Databases -->
  <mat-form-field appearance="outline" class="form-field-full">
    <mat-label>Databases</mat-label>
    <mat-chip-grid #dbChipGrid>
      <mat-chip-row *ngFor="let id of softwareData.databases" (removed)="removeChip('databases', id)">
        {{ getOptionName(databaseOptions, id) }}
        <button matChipRemove><mat-icon>cancel</mat-icon></button>
      </mat-chip-row>
      <input placeholder="Add database…" [matChipInputFor]="dbChipGrid" [matAutocomplete]="dbAuto"
        [(ngModel)]="dbSearchInput" (ngModelChange)="onDbSearch($event)">
    </mat-chip-grid>
    <mat-autocomplete #dbAuto="matAutocomplete"
      (optionSelected)="addChip('databases', $event.option.value); dbSearchInput = ''">
      <mat-option *ngFor="let opt of dbAutocompleteOptions" [value]="opt.id">{{ opt.name }}</mat-option>
    </mat-autocomplete>
  </mat-form-field>

  <!-- Development Tools -->
  <mat-form-field appearance="outline" class="form-field-full">
    <mat-label>Development Tools</mat-label>
    <mat-chip-grid #editorChipGrid>
      <mat-chip-row *ngFor="let id of softwareData.editors" (removed)="removeChip('editors', id)">
        {{ getOptionName(editorOptions, id) }}
        <button matChipRemove><mat-icon>cancel</mat-icon></button>
      </mat-chip-row>
      <input placeholder="Add tool…" [matChipInputFor]="editorChipGrid" [matAutocomplete]="editorAuto"
        [(ngModel)]="editorSearchInput" (ngModelChange)="onEditorSearch($event)">
    </mat-chip-grid>
    <mat-autocomplete #editorAuto="matAutocomplete"
      (optionSelected)="addChip('editors', $event.option.value); editorSearchInput = ''">
      <mat-option *ngFor="let opt of editorAutocompleteOptions" [value]="opt.id">{{ opt.name }}</mat-option>
    </mat-autocomplete>
  </mat-form-field>

  <!-- Miscellaneous -->
  <mat-form-field appearance="outline" class="form-field-full">
    <mat-label>Miscellaneous</mat-label>
    <mat-chip-grid #miscChipGrid>
      <mat-chip-row *ngFor="let id of softwareData.misc" (removed)="removeChip('misc', id)">
        {{ getOptionName(miscOptions, id) }}
        <button matChipRemove><mat-icon>cancel</mat-icon></button>
      </mat-chip-row>
      <input placeholder="Add software…" [matChipInputFor]="miscChipGrid" [matAutocomplete]="miscAuto"
        [(ngModel)]="miscSearchInput" (ngModelChange)="onMiscSearch($event)">
    </mat-chip-grid>
    <mat-autocomplete #miscAuto="matAutocomplete"
      (optionSelected)="addChip('misc', $event.option.value); miscSearchInput = ''">
      <mat-option *ngFor="let opt of miscAutocompleteOptions" [value]="opt.id">{{ opt.name }}</mat-option>
    </mat-autocomplete>
  </mat-form-field>

</div>
